<div
  class="container"
>
  @if (faIconName) {
    <div class="icon">
      <i [class]="faIconName"
      ></i>
    </div>
  }

  <div
    class="text"
    [innerHTML]="htmlText"
  >
  </div>

  @if (buttons) {
    <div class="buttons">
    </div>
  }
</div>
